

// DEPRECATED!!!!!

declare var $:any;

import * as moment from 'moment';
import { observable } from 'mobx';
import { GET_QUERY } from 'utils';

class MilestonesDataSource {
	@observable listeners:Array<any> = [];
	@observable milestones:Array<any> = [];

	addListener = (listenerToAdd) => {
		var idx = this.listeners.indexOf(listenerToAdd);
		if(-1===idx) {
			this.listeners.push(listenerToAdd);
		}
	}

	removeListener = (listenerToRemove) => {
		var idx = this.listeners.indexOf(listenerToRemove);
		if(-1!=idx){
			this.listeners.splice(idx, 1);
		}
	}

	notifyListeners = () => {
		this.listeners.forEach(listener => {
			listener();
		});		
	}

	load = () => {
		$.ajax(GET_QUERY('/page/progress'))
		.done(response => {
			this.milestones = response;
			this.notifyListeners();
		})
		.fail(() => {
			
		});	
	}

	processFeedItems = (feedItems) => {

		let changesHaveBeenMade = false; 

		// loop through and add any items that have points to the proper milestone
		for(let i=0, ii=feedItems.length;i<ii;i++){
			let feedItem = feedItems[i];
			if(feedItem.pointsAwarded && feedItem.pointsAwardedDate) {
				let pointsAwardedMoment = moment(feedItem.pointsAwardedDate);				

				for(let j=0,jj=this.milestones.length;j<jj;j++){
					let dayBeginMoment = moment(this.milestones[j].dayBegin).startOf('day');
					let dayEndMoment = moment(this.milestones[j].dayEnd).endOf('day');

					if(pointsAwardedMoment.isBetween(dayBeginMoment, moment(dayEndMoment))) {
						
						let feedItemForMilestone:any = {
							pointsAwarded:feedItem.pointsAwarded,
							pointsAwardedDate:feedItem.pointsAwardedDate,
							_id:feedItem._id
						};
						if(feedItem._post) {
							feedItemForMilestone.icon = feedItem._post.icon;
							feedItemForMilestone.name = feedItem._post.title;
						} else {
							feedItemForMilestone.icon = "icon-graph-filled";
							feedItemForMilestone.name = feedItem.content;							
						}

						this.milestones[j].feedItems.push(feedItemForMilestone);
						this.milestones[j].points += feedItem.pointsAwarded;
						changesHaveBeenMade = true;
						break;
					}
				}
			}
		}

		if(changesHaveBeenMade) this.notifyListeners();    
	}

	getMilestones = () => {
		return this.milestones;
	}

};


let milestonesDataSource = new MilestonesDataSource();
export { milestonesDataSource };
